var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumbsUp = function SvgThumbsUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.5971,
    height: 26.88635,
    viewBox: "0 0 27.5971 26.88635",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2449,11H21.34342a8.69391,8.69391,0,0,0,1.54047-4.5207c0-2.24071-.56017-3.92124-2.52076-4.34137-1.82055-.42013-2.52076.14005-2.94089,1.40044-.56017,1.40044-.56017,3.081-1.12034,4.06128a10.94782,10.94782,0,0,1-3.92118,4.48141C11.627,12.55188,10,12.30831,10,14.18172V25.38525a1.42547,1.42547,0,0,0,.98029,1.26039,18.616,18.616,0,0,1,4.90148,1.40044,9.49164,9.49164,0,0,0,4.6214.84027c2.49531,0,4.62139-.28009,5.74173-1.40044a4.184,4.184,0,0,0,.84025-3.221,3.3248,3.3248,0,0,0,.9803-3.64114,4.03924,4.03924,0,0,0,.56017-3.78119C30.72625,14.32177,29.18579,11,26.2449,11Z",
    transform: "translate(-2 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,13H3a1,1,0,0,0-1,1V26a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V14A1,1,0,0,0,8,13ZM4.5,18A1.5,1.5,0,1,1,6,16.5,1.5,1.5,0,0,1,4.5,18Z",
    transform: "translate(-2 -2)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbsUp.bce777d0.svg";
export { ForwardRef as ReactComponent };